export default __webpack_public_path__ + "static/media/hero-verification.2e68e614.svg";